
import { Link } from 'react-router-dom';
function Breadcrumb(props) {

  function isLast(index) {
     return index === props.crumbs.length - 1;
  }
  return (
    <nav className="breadcrumb" aria-label="breadcrumb">
      <ol>
        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link><span aria-hidden="true">/</span></li>
        {
          props.crumbs.map((crumb, ci) => {
            const disableClick = isLast(ci) ? 'lastdisable' : '';
            return (
              disableClick ? (
              <li
                key={ ci }
                className="breadcrumb-item"
              >
                <a tabIndex="0" className={ `${ disableClick }` } aria-current={disableClick ? 'page':''}>{ crumb.label }</a>
              </li>
              ):(
                <li
                key={ ci }
                className="breadcrumb-item"
              >
                <Link  to={"/" + crumb.url}>{ crumb.label }</Link>
                <span aria-hidden="true">/</span>
              </li>
              )
            );
          })
        }
      </ol>
    </nav>
  );
}
  
  export {Breadcrumb };